<template>
  <div v-if="showing">
    <div>
      <modal-mask></modal-mask>
    </div>

    <div class="draw-winning-wrapper" :style="`background: ${h5ConfigDetails[0]['fontColor']['secondaryPopBg'][0]};`">
      <img @click="_close" :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${h5ConfigDetails[0]['wholeImg']['secondaryPopClose'][0]}`" class="modal-close" alt="">
      <div class="draw-winning-head" :style="`color: ${h5ConfigDetails[0]['fontColor']['secondaryPopTitleColor'][0]};`">恭喜获得</div>
      <img v-if="!Number(activityConfig.clientParams.redeemAll)" class="prize-img" :src="`${baseUrl.portalImg}${h5ConfigImgPath}/${h5ConfigDetails[0]['drawLotteryImg']['prizesImg'][infoItems[0].imgIndex]}`" alt="">
      <div v-if="!Number(activityConfig.clientParams.redeemAll)" class="discript" :style="`color: ${h5ConfigDetails[0]['fontColor']['secondaryPopTxtColor'][0]};`">{{infoItems[0].name}}</div>
      <div v-if="Number(activityConfig.clientParams.redeemAll)" :class="`code-wrapper ${infoItems.length === 1 ? 'num-one' : infoItems.length === 2 ? 'num-two' : 'num-more'}`">
        <div class="code" :style="`color: ${h5ConfigDetails[0]['fontColor']['prizeNameOrInputFontColor'][0]};background: ${h5ConfigDetails[0]['fontColor']['inputBg'][0]};`" v-for="(item, idx) in infoItems" :key="idx">{{item}}</div>
      </div>
      <div class="prize-desc" :style="`color: ${h5ConfigDetails[0]['fontColor']['secondaryPopTxtColor'][0]};`">请前往“中奖记录”查看</div>
      <div class="win-btn" :style="`color: ${h5ConfigDetails[0]['fontColor']['secondaryPopBtnTxtColor'][0]};background: ${h5ConfigDetails[0]['fontColor']['secondaryPopBtnBg'][0]};`" @click="_close">确定</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { baseUrl } from '@/config/env'
import ModalMask from '@/components/modal/ModalMask'

export default {
  name: 'DrawWinning',
  components: {
    ModalMask
  },
  computed: {
    ...mapState(['h5ConfigDetails', 'h5ConfigImgPath', 'activityConfig'])
  },
  data () {
    return {
      baseUrl,
      showing: false,
      infoItems: []
    }
  },
  created () {

  },
  mounted () {

  },
  methods: {
    _close () {
      this.showing = false
    },
    show (infoItems) {
      this.infoItems = infoItems
      this.showing = true
    }
  },
  filter: {

  },
  watch: {

  }
}
</script>

<style scoped lang="less">
    @import '../../style/mixin';

  .draw-winning-wrapper {
    width: 29.7rem;
    height: auto;
    background: rgb(255, 247, 238);
    position: fixed;
    top: 50%;
    transform: translate(0, -50%);
    left: 0;
    right: 0;
    margin: auto;
    border-radius: 0.9rem;
    z-index: 1000;
    overflow: hidden;
    text-align: center;
    padding-bottom: 1rem;
  }

  .draw-winning-wrapper .draw-winning-head {
    font-size: 1.8rem;
    font-family: PingFangSC, PingFang SC;
    font-weight: bold;
    color: #7E3E1B;
    line-height: 2.6rem;
    margin: 1.7rem 0 1.3rem 0;
  }

  .draw-winning-wrapper .prize-desc {
    font-size: 1.07rem;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #B7704A;
    line-height: 1.4rem;
    margin-bottom: 0.87rem;
  }

  .draw-winning-wrapper .win-btn {
    width: 24.1rem;
    height: 4rem;
    background: linear-gradient(90deg, #FF8250 0%, #FF4C59 100%);
    border-radius: 2rem 2rem 2rem 2rem;
    opacity: 1;
    font-size: 1.6rem;
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 4rem;
    margin: auto;
  }

  .draw-winning-wrapper .prize-img {
    width: 12.7rem;
    height: auto;
  }

  .draw-winning-wrapper .discript {
    font-size: 1.33rem;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #A9420B;
    line-height: 2rem;
    margin: 0.33rem auto 1.27rem;
  }

  .code-wrapper {
    display: flex;
    flex-wrap: wrap;
    padding: 0 1.6rem 1.1rem;
    height: 11.5rem;
  }

  .num-one {
    justify-content: center;
    align-items: center;
  }

  .num-two {
    justify-content: space-between;
    align-items: center;
  }

  .num-more {
    justify-content: space-between;
    align-items: baseline;
    overflow-y: scroll;
    .code{
      margin-bottom: 1rem;
    }
  }

  .num-one .code {
    width: 15.9rem !important;
  }

  .draw-winning-wrapper .code {
    width: 12.9rem;
    height: 4.1rem;
    line-height: 4.1rem;
    background: #FDEDD6;
    border-radius: 0.6rem;
    opacity: 1;
    font-size: 13px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #7E3E1B;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    padding: 0 1rem;
  }

  .res-item-one {
    background: #FFE7E2;
    font-size: 1.5rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #590F0F;
    text-align: center;
    display: inline-block;
    padding: 1rem 0.7rem;
    border-radius: 0.6rem;
    margin: 1.6rem auto 2.3rem;
  }
</style>
